import { Component, Input, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { environment } from '../../../../environments/environment';

@Component({
  selector: 'app-header-questionario',
  templateUrl: './header-questionario.component.html',
  styleUrl: './header-questionario.component.scss',
})
export class HeaderQuestionarioComponent implements OnInit {
  @Input({ required: false }) valueMin: number = 0;
  @Input({ required: false }) valueMax: number = 100;
  @Input({ required: false }) progressoPercentual: number = 0;

  public logo = environment.logo_name;

  title: string = 'HSE';
  subtitle: string = 'HOME';

  constructor(private route: ActivatedRoute) {}

  ngOnInit(): void {
    this.route?.data?.subscribe((data) => {
      this.title = data['title'];
      this.subtitle = data['subtitle'];
    });
  }
}
